// Codifications that can be retrieved using web service /getCodifs.htm
// See ticket SAN-15
// See https://mobile-spot.atlassian.net/wiki/spaces/FR/pages/18677787/UserData+Networking+WebServices+request

const CODIFICATIONS_SOURCES = {
  EXHIBIS: 'EXHIBIS'
};
const CODIFICATIONS_ENTITIES = {
  INDIVIDUEVT: 'IndividuEvt'
};
const CODIFICATIONS_NAMES = {
  EVENEMENTFONCTION: 'EvenementFonction',
  CIVILITE: 'Civilite'
};
const CODIFICATION_FONCTION = {
  sourceCode: CODIFICATIONS_SOURCES.EXHIBIS,
  entityCode: CODIFICATIONS_ENTITIES.INDIVIDUEVT,
  nameField: CODIFICATIONS_NAMES.EVENEMENTFONCTION
};
const CODIFICATIONS_TO_AUTOMATICALLY_RETRIEVE = [CODIFICATION_FONCTION];
const FETCH_ON_LOGIN_SUCCESS = false;
module.exports = {
  CODIFICATION_FONCTION,
  CODIFICATIONS_TO_AUTOMATICALLY_RETRIEVE,
  FETCH_ON_LOGIN_SUCCESS
};